import { createSlice, createAsyncThunk, AsyncThunk } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export const filterChangeDriver: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "changedriver",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      filterUrls.changeDriver,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    );

    return data.data;
  }
);

const initialState: any = {
  driver: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const ChangeDriverSlice = createSlice({
  initialState: initialState,
  name: "changedriver",
  reducers: {
    clearDriver: (state) => {
      state.driver = [];
    },
    setFilterChangeDriver: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterChangeDriver.fulfilled as any]: (state, action) => {
      state.driver = action.payload;
      state.fetchPost = false;
    },
    [filterChangeDriver.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterChangeDriver.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterChangeDriver, clearDriver } = ChangeDriverSlice.actions;
export default ChangeDriverSlice.reducer;
